import {useCallback} from 'react';
import {Configuration} from 'configuration';
import {triggerDownloadBlob} from 'store/api/triggerDownloadBlob';
import type {Media} from '../types';
import {useGetMediaUrlQuery} from '../mediaApi';

export const useDownloadMediaUrl = (media: Pick<Media, 'id' | 'extension'>) => {
  const {data} = useGetMediaUrlQuery(media);

  return useCallback(() => {
    if (data) {
      fetch(data, {
        method: 'GET',
        referrer: Configuration.app.domain,
        credentials: 'include',
      })
        .then(response => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error('Empty blob');
          }
        })
        .then(blob => {
          triggerDownloadBlob(
            `${media.id}-${new Date().toLocaleString('no')}.${media.extension}`,
            blob,
          );
        })
        .catch(e => {
          console.error('useDownloadMediaUrl error', media, e);
        });
    } else {
      console.error('useDownloadMediaUrl error no uri', data, media);
    }
  }, [data, media]);
};
